import { createSlice } from "@reduxjs/toolkit";
import { transformDatePtBR } from "../../utils";

const assistantSlice = createSlice({
    name: 'assistant',
    initialState: {
        dados: {
            messages: [ { sender: "assistant", text: "Bem-vindo! Como posso te ajudar?", time: transformDatePtBR(new Date()) } ]
        },
        status: null
    },
    reducers: {
        setDataAssistant: (state, action) => {
            state.dados = action.payload;
        },
        setMessagesAssistant: (state, action) => {
            state.dados.messages = action.payload;
        },
    }
});

export const { setDataAssistant, setMessagesAssistant } = assistantSlice.actions;
export default assistantSlice.reducer;